module.exports = __webpack_public_path__ + "img/cart.676ac764.png";